import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteNavigationCustomization } from '../../api/portalGateway/navigationCustomization';

import { navigationCustomizationOptions } from './useNavigationCustomizationQuery';

export function useDeleteNavigationCustomizationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteNavigationCustomization,
    onMutate: async ({ itemId }) => {
      await queryClient.cancelQueries({
        queryKey: navigationCustomizationOptions().queryKey,
      });
      const previousNavigationCustomization = queryClient.getQueryData(
        navigationCustomizationOptions().queryKey
      );

      queryClient.setQueryData(
        navigationCustomizationOptions().queryKey,
        (oldData) => {
          if (oldData == null) {
            return oldData;
          }

          return {
            ...oldData,
            data: {
              ...oldData.data,
              dynamicNavigationItems:
                oldData.data.dynamicNavigationItems.filter(
                  (item) => item.id !== itemId
                ),
            },
          };
        }
      );

      return { previousNavigationCustomization };
    },
    onError: (error, variables, context) => {
      queryClient.setQueryData(
        navigationCustomizationOptions().queryKey,
        context?.previousNavigationCustomization
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: navigationCustomizationOptions().queryKey,
      });
    },
  });
}
